// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Client appointments (/client/appointments). */

.client-appointments__slots {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-2);
}

.client-appointments__slot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--ds-space-2) var(--ds-space-3);
}

.client-appointments__time {
  white-space: nowrap;
  unicode-bidi: isolate;
  direction: ltr;
}
`, "",{"version":3,"sources":["webpack://./src/normalUsers/components/appointments/Appointments.css"],"names":[],"mappings":"AAAA,gDAAgD;;AAEhD;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":["/* Client appointments (/client/appointments). */\n\n.client-appointments__slots {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-2);\n}\n\n.client-appointments__slot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--ds-space-2) var(--ds-space-3);\n}\n\n.client-appointments__time {\n  white-space: nowrap;\n  unicode-bidi: isolate;\n  direction: ltr;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
